import GlobalContext from 'GlobalContext';
import 'moment/locale/pt';
import 'react-toastify/dist/ReactToastify.css';
import AppRouter from 'routes/Router';

import { ChakraProvider, Stack } from '@chakra-ui/react';
import { ToastContainer } from 'react-toastify';

import Fonts from 'assets/Fonts';
import theme from 'theme';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <GlobalContext>
        <Stack h="100vh" gap="0">
          <ToastContainer
            autoClose={4000}
            pauseOnHover={false}
            position="bottom-right"
          />
          <Fonts />
          <AppRouter />
        </Stack>
      </GlobalContext>
    </ChakraProvider>
  );
}

export default App;
